var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.currentType,{tag:"component",class:_vm.classes,attrs:{"path":_vm.to,"url":_vm.url},on:{"btnClicked":_vm.handler}},[_vm._t("icon"),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }